const api = state => state || null;
const CSRFMiddlewareToken = state => state || '';
const abortReasons = state => state || global.abortReasons || [];

export default {
    api,
    CSRFMiddlewareToken,
    abortReasons,
};



// WEBPACK FOOTER //
// ./scripts/frontend/base/reducer/statics.js